export const harvardClassic = {
  id: 'harvard-classic',
  version: 2,
  renderer: 'enterprise',
  name: 'Harvard ATS Classic',
  layout: 'single-column',
  theme: 'classic-navy',
  persona: ['software', 'backend', 'java', 'python', 'engineering', 'mba', 'consulting'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 45,
    visual: 15,
    executive: 30,
    student: 10
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'education', 'skills'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-section'
  },
  metadata: {
    industry: ['Management Consulting', 'Law', 'Finance', 'Government'],
    companies: ['McKinsey', 'BCG', 'Bain', 'Accenture', 'Deloitte', 'Goldman Sachs', 'J.P. Morgan'],
    ats: ['Workday', 'Taleo', 'Lever', 'Greenhouse', 'SuccessFactors'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    density: 'high',
    columns: 1,
    experienceLevel: ['Mid-level', 'Senior', 'Executive'],
    careerStage: 'Professional',
    recommendedFor: ['Investment Bankers', 'Strategy Consultants', 'Corporate Lawyers', 'Software Engineers applying to traditional firms'],
    avoidFor: ['Designers', 'Front-end Developers', 'Creative Advertisers'],
    dna: ['Traditional', 'ATS-Perfect', 'Consulting', 'Minimalist', 'Serif'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 99,
      visualAppeal: 80
    },
    hiringManager: {
      firstImpression: "Highly structured, traditional, serious",
      scanningStyle: "Rapid top-to-bottom vertical scan",
      preferredStructure: "Work experience and education first",
      dislikes: ["Creative graphics", "Summary paragraphs exceeding 4 lines", "Skills rating bars"]
    },
    strategy: {
      goal: "Maximize ATS parsing compatibility and structural trust",
      focus: "Quantified leadership metrics and school credentials",
      avoid: ["Visual clutter", "Secondary column splits", "Bright accent highlights"]
    },
    psychology: {
      coreTraits: ["Trust", "Authority", "Professionalism", "Conservative corporate alignment"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Use conservative, results-driven, highly concise bullet points starting with action verbs. Never use design buzzwords.",
      rewriteStyle: "Formal, metric-driven, professional"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'projects', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': 'Georgia, "Times New Roman", Times, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--letter-spacing-display': '0.5px',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '6px',
    '--color-text-main': '#2F2F2F',       // Charcoal Dark Body
    '--color-text-light': '#777777'      // Gray Meta/Dates
  }
};
export default harvardClassic;
